var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.167 3.5C12.3822 3.5 9.7115 4.60625 7.74237 6.57538C5.77324 8.54451 4.66699 11.2152 4.66699 14H1.16699L5.70533 18.5383L5.78699 18.7017L10.5003 14H7.00033C7.00033 9.485 10.652 5.83333 15.167 5.83333C19.682 5.83333 23.3337 9.485 23.3337 14C23.3337 18.515 19.682 22.1667 15.167 22.1667C12.9153 22.1667 10.8737 21.245 9.40366 19.7633L7.74699 21.42C8.71915 22.3979 9.87538 23.1735 11.1489 23.7022C12.4225 24.2308 13.7881 24.502 15.167 24.5C17.9518 24.5 20.6225 23.3938 22.5916 21.4246C24.5607 19.4555 25.667 16.7848 25.667 14C25.667 11.2152 24.5607 8.54451 22.5916 6.57538C20.6225 4.60625 17.9518 3.5 15.167 3.5ZM14.0003 9.33333V15.1667L18.9587 18.1067L19.857 16.6133L15.7503 14.175V9.33333H14.0003Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotationIcon);
export default __webpack_public_path__ + "static/media/quotation-icon.994dfa3e3509e2d7f76421a442c66098.svg";
export { ForwardRef as ReactComponent };